import React from 'react';
import { useIntl } from 'react-intl';
import { Col, Container, Row } from 'reactstrap';
import { nextAsset } from '../../../../components/nextAsset';

export const SmartlinksLinkfireAlternativeHowItWorks: React.FC = () => {
  const intl = useIntl();

  return (
    <Container className="mt-5 pt-5">
      <p className="main-header text-center mb-3 mb-lg-5">
        {intl.formatMessage({
          id: 'sml.web.smart-links.linkfire_alternative.how_it_works.title',
          defaultMessage: 'How it works'
        })}
      </p>
      <Row className="align-items-center">
        <Col xs={12} lg={6} className="order-lg-2 mt-5 text-center">
          <img
            src={nextAsset(`images/smartLinks/alternative/how-it-works.png`, false, { w: 900 })}
            alt=""
            className="img-fluid"
            style={{ width: '60%' }}
          />
        </Col>
        <Col xs={12} lg={6} className="mt-5">
          <ol className="ps-4 fs-4">
            <li className="py-2">
              <strong>
                {intl.formatMessage({
                  id: 'sml.web.smart-links.linkfire_alternative.how_it_works.list.1.title',
                  defaultMessage: 'Choose what type of Smart Link you want to create.'
                })}
              </strong>
              <br />
              {intl.formatMessage({
                id: 'sml.web.smart-links.linkfire_alternative.how_it_works.list.1.description',
                defaultMessage: 'We offer three link types: Artist Bio Link, Release Link and Playlist (Custom) Link.'
              })}
            </li>
            <li className="py-2">
              <strong>
                {intl.formatMessage({
                  id: 'sml.web.smart-links.linkfire_alternative.how_it_works.list.2.title',
                  defaultMessage: 'Customize your Smart Link.'
                })}
              </strong>
              <br />
              {intl.formatMessage({
                id: 'sml.web.smart-links.linkfire_alternative.how_it_works.list.2.description',
                defaultMessage: 'Pick your music services, customize your URL,  change your photo and background image.'
              })}
            </li>
            <li className="py-2">
              <strong>
                {intl.formatMessage({
                  id: 'sml.web.smart-links.linkfire_alternative.how_it_works.list.3.title',
                  defaultMessage: 'Share your Smart Link with your audience.'
                })}
              </strong>
              <br />
              {intl.formatMessage({
                id: 'sml.web.smart-links.linkfire_alternative.how_it_works.list.3.description',
                defaultMessage: 'Use Smart Links on your website and across all of your social channels.'
              })}
            </li>
          </ol>
        </Col>
      </Row>
    </Container>
  );
};
